import { pageLoadingOn, pageLoadingOff, loadFavoristos } from './utilities.js';

jQuery(function(){
	
	loadFavoristos();
	// Adicionar e Remover produto na lista de favoritos atraves dos Thumb do produto
	$(document).on("click",".add-favorites .btn-favorites",function(){
		pageLoadingOn();
		var btn = $(this);
		var prodId = btn.attr("data-product-id");
		var dados = "";

		if(btn.hasClass("remove")){
			//removeFavorites(btn,prodId);
			dados = "remove-favorite=true&product_id="+prodId;
		}else{
			//addFavorites(btn,prodId);
			dados = "add-favorite=true&product_id="+prodId;
		}

		pageLoadingOff();
		$.ajax({
			type: "POST",
			url: "/meus-favoritos/",
			data: dados,
			dataType: "json",
			success:function(json){
				if($.isPlainObject(json)){
					// Efetuar Login
					window.location.href = '/login/';
					return false;
				}

				//var classReload = "";
				// Remover dos favoritos
				if(btn.hasClass("remove")){ 
					btn.removeClass("remove");
					$(".btn-favorites span.text").html("Adicionar aos Favoritos");
				}else{ //Adicionar aos favoritos	
					btn.addClass("remove");
					$(".btn-favorites span.text").html("Remover dos favoritos");
				}
				// reloadicons(classReload);
				// btn.removeClass("d-none");
			}
		});
	});

	// Remover produto atráves da página da lista de favoritos
	$(document).on("click",".favorites-list .favorite-list-item a.remover",function(){
		var prodId = $(this).attr("data-product-id");
		var pos = $(".favorites-list .favorite-list-item a.remover").index(this);

		$.ajax({
			type: "POST",
			url: "/meus-favoritos/",
			data: "remove-favorite=true&product_id="+prodId,
			dataType: "json",
			success:function(json){
				if($.isPlainObject(json)){
					// Efetuar Login
					window.location.href = '/login/';
					return false;
				}

				$($(".favorites-list .favorite-list-item").get(pos)).animate({opacity:0},"slow",function(){
					$(this).remove();
					if ($(".favorites-list .favorite-list-item").length==0){ 
						window.location.reload(true);
					}
				});
			}
		});
	});

	// Preencher thumb dos produtos que estão na lista de favoritos;
	if(window.favoritosIds != undefined){
		$(".product-thumb").each(function(){
			var btnFavorites = $(this).find(".btn-favorites");
			var pId = btnFavorites.attr("data-product-id");
			var favoritosIds = window.favoritosIds;
			if(favoritosIds.includes(pId)){
				btnFavorites.addClass("remove");
			}
		});
	}

	// Preencher o ícone na página do produto
	if($(".product-info .btn-favorites").length == 1 && window.favoritosIds != undefined){
		const btnIcon = $(".product-info .btn-favorites");
		const pId = btnIcon.attr("data-product-id");
		const favoritosIds = window.favoritosIds;
		if(favoritosIds.includes(pId)){
			btnIcon.addClass("remove");
			$(".btn-favorites span.text").html("Remover dos favoritos");
		}
	}
});
